import tagTester from './_tagTester.js';

export default tagTester('ArrayBuffer');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isArrayBuffer.js
// module id = 651
// module chunks = 0